module.exports = __webpack_public_path__ + "intuit-card-bottom-right@2x.7L5tFSzp.png";